export default "__VITE_ASSET__BTXpB_WQ__"